<template>
	<section id="features" class="bg-secondary ptb-90">
		<div class="container">
			<div class="row">
				<div class="col-md-12">
					<div class="section-heading text-center">
						<h3>Fonctionnalités de CoproPrivée</h3>
						<p>
							Le rôle du logiciel est de vous permettre de gérer le plus facilement et efficacement.
							Continually network virtual strategic theme areas vis-a-vis ubiquitous
							potentialities.</p>
					</div>
				</div>
			</div>
			<div class="row align-items-center">
				<div class="col-md-4 hidden-sm hidden-xs">
					<div class="feature-image">
						<img src="img/feature-image.png" class="pos-hcenter img-responsive" alt="">
					</div>
				</div>
				<div class="col-md-4 col-sm-6">

					<div class="single-feature mb-5" v-for="(item, i) in items">
						<div class="feature-icon">
							<div class="icon icon-shape bg-color white-text">
								<i :class="'fa fa-'+item.icon"></i>
							</div>
						</div>
						<div class="feature-content">
							<h5>{{item.title}}</h5>
							<p class="mb-0">{{item.detail}}</p>
						</div>
					</div>

					<!--feature single start-->
					<div class="single-feature mb-5">
						<div class="feature-icon">
							<div class="icon icon-shape bg-color white-text">
								<i class="fa fa-dropbox"></i>
							</div>
						</div>
						<div class="feature-content">
							<h5>Loaded with features</h5>
							<p class="mb-0">Modular and interchangable componente between layouts and even demos.</p>
						</div>
					</div>
					<!--feature single end-->
					<!--feature single start-->
					<div class="single-feature mb-5">
						<div class="feature-icon">
							<div class="icon icon-shape bg-color white-text">
								<i class="fa fa-smile-o"></i>
							</div>
						</div>
						<div class="feature-content">
							<h5>Friendly online support</h5>
							<p class="mb-0">Modular and interchangable componente between layouts and even demos.</p>
						</div>
					</div>
					<!--feature single end-->
				</div>
				<div class="col-md-4 col-sm-6">
					<!--feature single start-->
					<div class="single-feature mb-5">
						<div class="feature-icon">
							<div class="icon icon-shape bg-color white-text">
								<i class="fa fa-file-archive-o"></i>
							</div>
						</div>
						<div class="feature-content">
							<h5>Free updates forever</h5>
							<p class="mb-0">Modular and interchangable componente between layouts and even demos.</p>
						</div>
					</div>
					<!--feature single end-->
					<!--feature single start-->
					<div class="single-feature mb-5">
						<div class="feature-icon">
							<div class="icon icon-shape bg-color white-text">
								<i class="fa fa-adjust"></i>
							</div>
						</div>
						<div class="feature-content">
							<h5>Infinite colors</h5>
							<p class="mb-0">Modular and interchangable componente between layouts and even demos.</p>
						</div>
					</div>
					<!--feature single end-->
					<!--feature single start-->
					<div class="single-feature mb-5">
						<div class="feature-icon">
							<div class="icon icon-shape bg-color white-text">
								<i class="fa fa-smile-o"></i>
							</div>
						</div>
						<div class="feature-content">
							<h5>Friendly online support</h5>
							<p class="mb-0">Modular and interchangable componente between layouts and even demos.</p>
						</div>
					</div>
					<!--feature single end-->
				</div>
			</div>

		</div>
	</section>
</template>
<style lang="less" scoped>

	/*==================================
						FEATURE SECTION CSS
	===================================*/

	.align-items-center {
		align-items: center!important;
	}

	.single-feature{
		align-items: flex-start!important;
		display: flex!important;
		padding: 1.5em 1em;
		cursor: pointer;
		transition: all 0.3s ease-in;
	}

	.feature-icon{
		margin-right: 20px;
		transition: all 0.3s ease-in;
	}
	.icon-shape {
		text-align: center;
		border-radius: .25rem;
		align-items: center;
		justify-content: center;
	}

	.icon {
		display: inline-flex;
		min-width: 2.75rem;
		min-height: 2.75rem;
		box-shadow: 0 1px 2px 0 rgba(0,0,0,0.12);
		color: inherit;
		transition: all 0.3s ease-in;
	}
	.icon-shape i{
		font-size: 1.2rem;
	}

	.feature-content h5{
		font-size: 16px;
		line-height: 22px;
		margin-bottom: 5px;
	}
	.single-feature:hover .icon{
		border-radius: 50%;
	}
</style>
<script>
	export default{
		data: function(){
			return {
				items:[
					{icon:'x', title:'Responsive web design', detail:'Modular and interchangable componente between layouts and even demos.'},
					{icon:'x', title:'Notificatins', detail:'Mail, SMS intégrées'},
					{icon:'x', title:'Extranet', detail:''},
					{icon:'x', title:'Génération des documents.', detail:''},
					{icon:'x', title:'Import et export de vos données', detail:''},
				]
			}
		}
	}
</script>